import type { SearchableRoute } from '@cplug/frontend-core/models'
import { openLegacySSO } from '~/shared/composables/useLegacySSORedirect'

const SSO_ACTIONS: Record<string, string> = {
  'label-models': 'etiquetas',
  'bank-slips': 'boletos'
}

export function useErpSearchNavigate (route: SearchableRoute): boolean {
  const module = route.action ? SSO_ACTIONS[route.action] : undefined

  if (!module) {
    return false
  }

  openLegacySSO(module).catch(() => {})

  return true
}
